import React from 'react'
import { motion } from 'framer-motion'
import { useParams } from 'react-router-dom'

const FamilyDashboard: React.FC = () => {
  const { groupId } = useParams<{ groupId: string }>()

  return (
    <motion.div
      className="min-h-screen bg-warm-background py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-xl shadow-lg p-8">
            <h1 className="text-serif text-3xl font-bold text-space-cadet-primary mb-6 text-center">
              Family Collaboration Dashboard
            </h1>

            <div className="text-center py-12">
              <div className="w-16 h-16 bg-gradient-blue rounded-full mx-auto mb-6 flex items-center justify-center">
                <span className="text-white text-3xl">👨‍👩‍👧‍👦</span>
              </div>

              <h2 className="text-2xl font-semibold text-space-cadet-primary mb-4">
                Real-Time Family Collaboration
              </h2>

              <p className="text-cool-gray text-lg mb-8 max-w-2xl mx-auto">
                This dashboard will enable up to 5 people (you plus 4 others) to collaborate in real-time
                on eulogy creation for group ID: {groupId}
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-pink-lavender/10 border border-pink-lavender/20 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-space-cadet-primary mb-3">
                    Collaboration Features:
                  </h3>
                  <ul className="text-left space-y-2 text-cool-gray">
                    <li>• Real-time activity feed</li>
                    <li>• Live presence indicators</li>
                    <li>• Shared memory contributions</li>
                    <li>• Media upload and sharing</li>
                    <li>• Comment and approval system</li>
                  </ul>
                </div>

                <div className="bg-cool-gray/10 border border-cool-gray/20 rounded-lg p-6">
                  <h3 className="text-lg font-semibold text-space-cadet-primary mb-3">
                    Family Management:
                  </h3>
                  <ul className="text-left space-y-2 text-cool-gray">
                    <li>• Invite up to 4 family members or friends</li>
                    <li>• Manage permissions and roles</li>
                    <li>• Track contribution history</li>
                    <li>• Family group settings</li>
                    <li>• Subscription management</li>
                  </ul>
                </div>
              </div>

              <button className="bg-space-cadet-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-space-cadet-secondary transition-colors duration-200">
                Coming Soon
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default FamilyDashboard